<template>
  <el-menu default-active="6" :collapse="collapsed" collapse-transition router :default-active="$route.path"
           class="el-menu-vertical-demo" background-color="#ffffff" text-color="#000000"
           active-text-color="#0052D9">
    <div class="logobox" @click="home()">
      锦胜雾森智慧管理平台
    </div>
    <el-submenu v-for="menu in allmenu" @click.native="goNav(menu.url)" :key="menu.menuid" :index="menu.menuname"
                :id="'menu_'+menu.menuid">
      <template slot="title">
        <el-image :src="`/static/images/` + menu.icon" style="width: 20px;height: 20px;"></el-image>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
  export default {
    name: 'leftnav',
    data() {
      return {
        collapsed: false,
        allmenu: []
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      let res = [
        {
          menuid: 6,
          icon: 'jiankong.png',
          menuname: '监控平台',
          url: '/supervise/index'
        },
        {
          menuid: 10,
          icon: 'shebei.png',
          menuname: '设备管理',
          url: null,
          menus: [
            {
              menuid: 11,
              menuname: '分组列表',
              url: 'device/group',
              menus: null
            }, {
              menuid: 7,
              menuname: '设备列表',
              url: 'device/index',
              menus: null
            }
          ]
        }, {
          menuid: 12,
          icon: 'renwu.png',
          menuname: '任务管理',
          url: '/task/index',
        }, {
          menuid: 14,
          icon: 'baojing.png',
          menuname: '报警信息',
          url: null,
          menus: [
            {
              menuid: 15,
              icon: 'icon-order-manage',
              menuname: '历史报警',
              url: 'alarm/index',
            }, {
              menuid: 16,
              icon: 'icon-order-manage',
              menuname: '当前报警',
              url: 'alarm/current',
            }
          ]
        },
        {
          menuid: 18,
          icon: 'geren.png',
          menuname: '个人中心',
          url: null,
          menus: [
            {
              menuid: 19,
              menuname: '人员管理',
              url: 'user/index',
            },
            {
              menuid: 20,
              menuname: '更改电话',
              url: 'user/phone',
            }
          ]
        },
        {
          menuid: 21,
          icon: 'xieyi.png',
          menuname: '协议与说明',
          url: '/protocal/index',
        },
        {
          menuid: 22,
          icon: 'jiaocheng.png',
          menuname: '操作教程',
          url: '/course/index',
        },
        /*{
          menuid: 23,
          icon: 'jiaocheng.png',
          menuname: '维修/保养',
          url: '/repair/index',
        },*/
      ];
      this.allmenu = res
      this.$root.Bus.$on('toggle', value => {
        this.collapsed = !value
      })
    },
    methods: {
      home() {
        this.$router.push({path: '/home/index'})
      },
      goNav(url) {
        if (url) {
          this.$router.push({path: url})
        }
      }
    }
  }
</script>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
  }

  .el-menu-item-group__title {
    padding: 0px;
  }

  .el-menu-bg {
    background-color: #ffffff !important;
  }

  .el-menu {
    border: none;
  }

  .logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 20px 0px;
  }

  #menu_6 i, #menu_12 i, #menu_18 i, #menu_21 i, #menu_22 i {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue